import { create } from 'zustand';
import type { UserStatus } from '@/lib/types';

interface UserState {
  platformUserId: string | null;
  platformUserEmail: string | null;
  platformUserName: string | null;
  userStatus: UserStatus | null;
  requiresAuth: boolean;
  authUrl: string | null;

  setPlatformUser: (userId: string, email: string, name: string) => void;
  setUserStatus: (status: UserStatus | null, requiresAuth?: boolean, authUrl?: string) => void;
  reset: () => void;
}

export const useUserStore = create<UserState>((set) => ({
  platformUserId: null,
  platformUserEmail: null,
  platformUserName: null,
  userStatus: null,
  requiresAuth: false,
  authUrl: null,

  setPlatformUser: (userId, email, name) => {
    set((state) => {
      // Only update if values actually changed
      if (
        state.platformUserId === userId &&
        state.platformUserEmail === email &&
        state.platformUserName === name
      ) {
        return state; // No change
      }

      console.log('[UserStore] Setting platform user:', { userId, email, name });
      return {
        platformUserId: userId,
        platformUserEmail: email,
        platformUserName: name,
      };
    });
  },

  setUserStatus: (status, requiresAuth = false, authUrl = undefined) => {
    console.log('[UserStore] Setting user status:', { status, requiresAuth, authUrl });
    set({
      userStatus: status,
      requiresAuth,
      authUrl: authUrl || null,
    });
  },

  reset: () => {
    set({
      platformUserId: null,
      platformUserEmail: null,
      platformUserName: null,
      userStatus: null,
      requiresAuth: false,
      authUrl: null,
    });
  },
}));
